import { Directive, ViewContainerRef, Input, TemplateRef, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appIntegerOnly]'
})
export class IntegerOnlyDirective {

  @Input('allowNegative') allowNegative = false;
  private positiveRegex: RegExp = new RegExp(/^[0-9]*$/);
  private negativeRegex: RegExp = new RegExp(/^-?[0-9]*$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

  constructor(private el: ElementRef) {
  }


  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (event.ctrlKey || this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const text: string = this.el.nativeElement.value.concat(event.key);

    if (text &&
      ((!this.allowNegative && !String(text).match(this.positiveRegex))
        || (this.allowNegative && !String(text).match(this.negativeRegex)))
    ) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  oninput(event) {
    if (this.allowNegative)
      return;
    if (!isNaN(this.el.nativeElement.value) && +this.el.nativeElement.value < 0) {
      this.el.nativeElement.value = '0';
      event.preventDefault();
    }
  }

}
